// Same check the backend applies to every id these forms send.
const OBJECT_ID_RE = /^[0-9a-f]{24}$/i;

/** → '' when valid, otherwise the inline error to show. */
export const validateObjectId = (value) => {
  if (!value) return 'This field is required';
  if (!OBJECT_ID_RE.test(value)) return 'Must be a 24-character ID';
  return '';
};

// The backend stores and echoes ids lowercased, so compare and send them that way.
export const normaliseId = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();
